import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registra il Service Worker per PWA + notifiche push
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((reg) => {
      // Listener per navigazione da click su push notification
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'navigate' && event.data.url) {
          const target = event.data.url;
          try {
            const u = new URL(target, window.location.origin);
            if (u.origin === window.location.origin) {
              window.history.pushState({}, '', u.pathname + u.search + u.hash);
              window.dispatchEvent(new PopStateEvent('popstate'));
              return;
            }
          } catch (e) {}
          window.location.href = target;
        }
      });
    }).catch((e) => console.warn('SW registration failed', e));
  });
}
